module.exports = __webpack_public_path__ + "static/img/background.4372d03d.svg";